import axios, { AxiosResponse } from "axios";

class Service {
    public async Post(controller: string, data: any, route?: string): Promise<AxiosResponse<any>> {
        return axios.post(`api/${controller}` + (typeof route !== 'undefined' ? `/${route}` : ''), data);
    }
    public async Delete(controller: string, id: any, route?: string): Promise<AxiosResponse<any>> {
        return axios.delete(`api/${controller}` + (typeof route !== 'undefined' ? `/${route}` : '') + `/${id}`);
    }
    public async Get(controller: string, route?: string): Promise<AxiosResponse<any>> {
        return this.GetById(controller, undefined, route);
    }

    public async GetById(controller: string, id?: any, route?: string): Promise<AxiosResponse<any>> {
        return axios.get(`api/${controller}` + (typeof route !== 'undefined' ? `/${route}` : '') + (typeof id !== 'undefined' ? `/${id}` : ''));
    }
}

export const GenericService: Service = new Service();
